import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../data/enums'
import Iris from './Iris/Iris'

export default function FaceFeature({
  scaleX,
  scale,
  gradient,
  pupil,
  rotation = 0,
  spacing = 0,
  verticalOffset,
  outline,
  showEyeLiner,
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftPupilTransformOrigin = '16.72 15.08'
  const rightPupilTransformOrigin = '42.72 15.08'

  const leftEyePath = 'M24.72,19.61s.09-9.53-7.97-9.99c-6.71-.39-12.03,8.65-12.03,8.65l20,1.34Z'
  const rightEyePath = 'M34.72,19.61s-.09-9.53,7.97-9.99c6.71-.39,12.03,8.65,12.03,8.65l-20,1.34Z'

  return (
    <>
      <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
        {/* LEFT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${-spacing})`} transform-origin={leftPupilTransformOrigin}>
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path className="cls-4" d={leftEyePath} fill={COLORS.WHITE} />
            <Iris
              rotation={-rotation}
              maskPath={leftEyePath}
              gradientId={randomGradientId1}
              transformOrigin={leftPupilTransformOrigin}
            />
            <path
              className="cls-6"
              d="M16.72,17.58c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
              fill={pupil}
            />
            <path
              className="cls-5"
              d="M25.22,20.14l-21.34-1.43,.41-.7c.22-.38,5.55-9.28,12.49-8.89,8.44,.48,8.44,10.39,8.44,10.49v.53Zm-19.62-2.32l18.6,1.25c-.11-1.96-.98-8.58-7.48-8.95-5.26-.29-9.73,5.64-11.12,7.71Z"
              fill={outline}
            />
            {showEyeLiner && (
              <path d="M25.22,20.14c-1.72-8.82-8.2-12.8-15.73-6.73-2,1.55-3.84,3.37-5.61,5.3,1.17-2.35,2.78-4.5,4.73-6.34,7.56-7.44,17.2-2.61,16.61,7.77h0Z" />
            )}
          </g>
          <path
            className="cls-4"
            d="M18.39,14.23c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83-.83,.37-.83,.83,.37,.83,.83,.83Z"
            fill={COLORS.WHITE}
          />
        </g>
        {/* RIGHT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${spacing})`} transform-origin={rightPupilTransformOrigin}>
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path className="cls-4" d={rightEyePath} fill={COLORS.WHITE} />
            <Iris
              rotation={rotation}
              maskPath={rightEyePath}
              gradientId={randomGradientId2}
              transformOrigin={rightPupilTransformOrigin}
            />
            <path
              className="cls-6"
              d="M42.72,17.58c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
              fill={pupil}
            />
            <path
              className="cls-5"
              d="M34.23,20.14v-.53c0-.1,0-10.01,8.44-10.49,6.94-.41,12.27,8.51,12.49,8.89l.41,.7-21.34,1.43Zm8.88-10.03c-.13,0-.26,0-.39,.01-6.51,.37-7.37,6.99-7.48,8.95l18.6-1.25c-1.36-2.02-5.65-7.72-10.74-7.72Z"
              fill={outline}
            />
            {showEyeLiner && (
              <path d="M55.56,18.71c-4.33-5.03-12.46-12.28-18.29-5.44-1.54,1.87-2.45,4.33-3.05,6.87-.2-2.68,.39-5.44,1.89-7.73,6.42-8.4,15.96-.83,19.45,6.3h0Z" />
            )}
          </g>
          <path
            className="cls-4"
            d="M44.39,14.23c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83-.83,.37-.83,.83,.37,.83,.83,.83Z"
            fill={COLORS.WHITE}
          />
        </g>
      </g>

      <defs>
        <clipPath id="clippath">
          <rect className="cls-1" x="4.72" y="10.06" width="20" height="9" />
        </clipPath>
        <linearGradient
          id={randomGradientId1}
          x1="16.72"
          y1="111.98"
          x2="16.72"
          y2="121.26"
          gradientTransform="translate(0 131.24) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
        <clipPath id="clippath-1">
          <rect className="cls-1" x="34.72" y="10.06" width="20" height="9" />
        </clipPath>
        <linearGradient
          id={randomGradientId2}
          x1="42.72"
          y1="111.97"
          x2="42.72"
          y2="121.26"
          gradientTransform="translate(0 131.24) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </>
  )
}
